<button
  type="button"
  (click)="userMenu.toggle($event)"
  class="flex items-center flex-shrink-0 gap-2 px-3 py-2 transition-colors rounded-full hover:bg-gray-100"
>
  <!-- Avatar -->
  <div
    class="flex items-center justify-center w-10 h-10 rounded-full bg-blue-100 text-blue-700"
  >
    <span class="text-sm font-semibold">{{ userInitials }}</span>
  </div>

  <!-- Nome (oculto em mobile) -->
  <span class="hidden text-sm font-medium text-gray-900 sm:inline">{{
    userName
  }}</span>

  <!-- Seta (oculta em mobile) -->
  <span class="hidden text-gray-600 material-icons sm:inline">
    keyboard_arrow_down
  </span>
</button>

<p-menu
  #userMenu
  [popup]="true"
  [model]="userMenuItems"
  appendTo="body"
></p-menu>
